const navDetailsElements = Array.from(
  document.querySelectorAll('nav details')
).filter(elem => elem.querySelector('ul.header__submenu') && window.innerWidth >= 769 );

console.log("navDetailsElements", navDetailsElements)

navDetailsElements.forEach(navDetailElement => {
  
  navDetailElement.addEventListener('mouseenter', () => {
    
    navDetailElement.setAttribute('open', '');


    if(!(navDetailElement.closest('ul').classList.contains('header__submenu'))) {
      return // as it is top level element
    }
    
    // if(navDetailElement.querySelector('ul')){
    //   if(navDetailElement.querySelector('ul').querySelector('ul')){
    //     console.log("returning", navDetailElement.id) 
    //     return
    //   }
    // }

      if(navDetailElement.querySelector('summary')){
          if(!(navDetailElement.querySelector('summary').querySelector('.triangle-caret'))){
        navDetailElement.querySelector('summary').innerHTML += `
            <svg class="triangle-caret" width="10" height="87" viewBox="0 0 100 87" xmlns="http://www.w3.org/2000/svg" style="
              width: 10px;
              fill: white;
              position: absolute;
              right: -2px;
              z-index: 4444;
              transform: rotate(270deg);
          ">
              <!-- Points form an equilateral triangle -->
              <polygon points="50,0 100,87 0,87" fill="white" style="
              border: 1px solid black;
          "></polygon>
            </svg>`
        
          }
      }
    

      const submenu = navDetailElement.querySelector('ul.header__submenu');

        // 1. Ensure submenu is visible
        submenu.style.opacity = '1';
        submenu.style.transform = 'translateY(0)';
                
        if (!submenu.classList.contains('submenu-slide-down')) {
          submenu.classList.add('submenu-slide-down');
        }
            
      const navRect = navDetailElement.getBoundingClientRect();
      const submenuHeight = submenu.offsetHeight || submenu.scrollHeight;
      const projectedBottom = navRect.bottom + submenuHeight;
      
      const isPartiallyHidden = projectedBottom > window.innerHeight;
      
      console.log({ projectedBottom, windowHeight: window.innerHeight });
      
      if (isPartiallyHidden) {
        submenu.style.top = 'unset';
        submenu.style.bottom = '-50px';
      } else {
        submenu.style.top = '-10px';
        submenu.style.bottom = 'unset';
      }
          

    
  });

  navDetailElement.addEventListener('mouseleave', () => {
    
    navDetailElement.removeAttribute('open');
    const submenu = navDetailElement.querySelector('ul.header__submenu');
    submenu.classList.remove('submenu-slide-down');
    void submenu.offsetWidth;

    if (navDetailElement.querySelector('.triangle-caret')) {
      navDetailElement.querySelector('.triangle-caret').remove();
    }


  });

  // navDetailElement.querySelector('summary').addEventListener('click', (e) => {
  //   e.preventDefault(); // disables click toggle
  // });
  
  // navDetailElement.addEventListener('click', (e) => {
  //   e.preventDefault(); // disables click toggle
  // });
  
})


